module.exports = __webpack_public_path__ + "static/media/superprimelogo.7b5ed6b3.png";